import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Header from "./Header";
import TrendingCarousel from "../utils/TrendingCarousel.jsx";
import MoviesCarousel from "../utils/MoviesCarousel.jsx";
import { MdArrowForwardIos } from "react-icons/md";
import * as moviesActions from "../utils/Redux/moviesSlice.js";
import "swiper/css";
import { TrendingSection } from "../utils/TrendingSection.jsx";
import { SectionCarousels } from "../utils/SectionCarousels.jsx";
const Browse = () => {
  const dispatch = useDispatch();

  const moviesIndex = [...Array(8).keys()];
  const nowPlayingMovies = useSelector(
    (state) => state.movies.nowPlayingMovies,
  );
  // eslint-disable-next-line no-unused-vars

  const nowPlayingIndex = [...Array(3).keys()];

  // Fetch and process data function
  const fetchData = async (url, action) => {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        // Log the status code and the response text for debugging
        const errorText = await response.text(); // Get the raw response text
        console.error("Error fetching data:", response.status, errorText);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json(); // Await the JSON parsing
      // console.log("Browse page response:", data);
      const shuffledMovies = shuffleArray(data.results);
      const uniqueMovies = getUniqueAndFilteredMovies(shuffledMovies);
      dispatch(action(uniqueMovies));
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const fetchTrendingMovies = async (url, action) => {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        // Log the status code and the response text for debugging
        const errorText = await response.text(); // Get the raw response text
        console.error("Error fetching data:", response.status, errorText);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json(); // Await the JSON parsing
      const uniqueMovies = getUniqueAndFilteredMovies(data.results);
      dispatch(action(uniqueMovies));
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const fetchMoviesByGenre = async (
    id,
    action,
    page = 1,
    accumulatedMovies = [],
  ) => {
    try {
      const url = `${process.env.REACT_APP_VERCEL_BACKEND_API_URL}/api/movies?genre=${id}&page=${page}`;
      const response = await fetch(url);
      if (!response.ok) {
        // Log the status code and the response text for debugging
        const errorText = await response.text(); // Get the raw response text
        console.error("Error fetching data:", response.status, errorText);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json(); // Await the JSON parsing
      const uniqueMovies = getUniqueAndFilteredMovies(data.results);
      const combinedMovies = [...accumulatedMovies, ...uniqueMovies];
      dispatch(action(combinedMovies));
      if (combinedMovies.length >= moviesIndex.length) {
        return;
      }
      if ((await response.json()).data.total_pages > page) {
        fetchMoviesByGenre(id, action, page + 1, combinedMovies);
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  // Shuffle array function
  const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };

  // Filter unique and valid movies
  const getUniqueAndFilteredMovies = (array) => {
    const seenTitles = new Set();
    return array.filter((movie) => {
      const title = movie.title || movie.name; // Use title for movies, name for TV shows
      if (
        seenTitles.has(title) ||
        !movie.backdrop_path ||
        !movie.poster_path ||
        !movie.id
      ) {
        return false;
      } else {
        seenTitles.add(title);
        return true;
      }
    });
  };

  useEffect(() => {
    const page = 1;
    fetchData(
      `${process.env.REACT_APP_VERCEL_BACKEND_API_URL}/api/movie/now_playing/${page}`,
      moviesActions.setNowPlayingMovies,
    );
    // fetchData(requests.fetchTrendingWeek, moviesActions.setTrendingMovies);
    fetchTrendingMovies(
      `${process.env.REACT_APP_VERCEL_BACKEND_API_URL}/api/trending/movie/week/${page}`,
      moviesActions.setTrendingMovies,
    );
    fetchData(
      `${process.env.REACT_APP_VERCEL_BACKEND_API_URL}/api/movie/indian/${page}`,
      moviesActions.setIndianMovies,
    );
    fetchData(
      `${process.env.REACT_APP_VERCEL_BACKEND_API_URL}/api/movie/marathi/${page}`,
      moviesActions.setMarathiMovies,
    );
    fetchData(
      `${process.env.REACT_APP_VERCEL_BACKEND_API_URL}/api/trending/tv/day`,
      moviesActions.setTrendingTvShows,
    );
    fetchMoviesByGenre(28, moviesActions.setActionMovies);
    fetchMoviesByGenre(16, moviesActions.setAnimationMovies);
    fetchMoviesByGenre(9648, moviesActions.setMysteryMovies);
    fetchMoviesByGenre(80, moviesActions.setCrimeMovies);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <div className="relative z-0 h-fit w-fit overflow-hidden bg-black bg-opacity-65">
      <Header />
      {/* black transition */}
      <div className="pointer-events-none absolute left-0 top-0 z-10 min-h-[440vh] w-[80vw] bg-gradient-to-r from-black/70 to-transparent transition-opacity duration-500" />
      {/* background screen increasing component */}
      <div className="absolute top-0 z-[-1] flex h-[440vh] w-screen bg-black bg-opacity-80" />
      {/* Hero Section */}
      <div className="relative top-2 grid h-fit grid-cols-[70vw_30vw]">
        <div className="relative ml-3 overflow-hidden rounded-2xl border border-white shadow-custom-red-bottom-right">
          <TrendingCarousel type="movie" />
        </div>
        <div className="relative ml-6 flex h-fit w-[25vw] flex-shrink-0 flex-col gap-2">
          <div className="relative flex items-start justify-start gap-2 p-2">
            <span className="relative flex h-fit w-fit text-2xl font-semibold text-white">
              Now Playing
            </span>
            <span className="relative mt-1 text-2xl">
              <Link to={`/discover?movies=NowPlaying`}>
                <button>
                  <MdArrowForwardIos fill="white" />
                </button>
              </Link>
            </span>
          </div>
          {nowPlayingIndex.map((index) => (
            <div
              key={index}
              className="relative h-[23vh] flex-shrink-0 overflow-hidden rounded-2xl shadow-md shadow-black hover:scale-110 hover:border-2 hover:border-white focus:border-white"
            >
              <MoviesCarousel movie={nowPlayingMovies[index]} />
            </div>
          ))}
        </div>
      </div>

      {/* Trending Movies */}
      <TrendingSection />
      {/* Indian Movies */}
      <SectionCarousels
        title="Indian Movies"
        link="Indian"
        movieType="indianMovies"
      />
      {/* Marathi Movies */}
      <SectionCarousels
        title="Marathi Movies"
        link="Marathi"
        movieType="marathiMovies"
      />
      {/* Movieflix Specials */}
      <SectionCarousels
        title="Movieflix Specials"
        link="specials"
        movieType="firebaseMovies"
        isFirebaseMovie={true}
      />
      {/* Action Movies */}
      <SectionCarousels
        title="Action Movies"
        link="28"
        movieType="actionMovies"
        genreType="genre"
      />
      {/* Animation Movies */}
      <SectionCarousels
        title="Animation Movies"
        link="16"
        movieType="animationMovies"
        genreType="genre"
      />
      {/* Mystery Movies */}
      <SectionCarousels
        title="Mystery Movies"
        link="9648"
        movieType="mysteryMovies"
        genreType="genre"
      />
      {/* Crime Movies */}
      <SectionCarousels
        title="Crime Movies"
        link="80"
        movieType="crimeMovies"
        genreType="genre"
      />
    </div>
  );
};

export default Browse;
